<script>
/* Translations can be used by calling trans/transMobile function or by creating Computed property.

1) trans/transMobile function example:
  trans('Response saved!')
  transMobile('signatureButtonText')

2) Computed property example:
  computed: {
    errorMessageRequiredFill () {
      return this.$store.getters.translationMobileByHandleString('defaultErrorMessage')
    }
  }
*/
export default {
  name: 'Translations',
  methods: {
    translationsInit (translationsHandleStrings, callbackFnc) {
      const translationsFromStore = this.$store.getters.translations
      let translationsMissing = []
      if (Object.keys(translationsFromStore).length > 0) {
        translationsHandleStrings.forEach(handleString => {
          if (!Object.hasOwnProperty.call(translationsFromStore, handleString)) {
            translationsMissing.push(handleString)
          }
        })
      } else {
        translationsMissing = translationsHandleStrings
      }
      if (translationsMissing.length) {
        this.$store.dispatch('addTranslations', translationsMissing.reduce((r, v) => { r[v] = v; return r }, {}))
        this.fetchNest('site/ajax.php?act=translations', { handle_strings: translationsMissing }, undefined, undefined, 'post', undefined, true, 0, false)
          .then(response => {
            if (response !== null) {
              this.$store.dispatch('addTranslations', response.translations)
              if (callbackFnc) {
                callbackFnc.apply()
              }
            }
          })
      } else if (callbackFnc) {
        callbackFnc.apply()
      }
    },
    translationsMobileInit (translationsMobileHandleStrings) {
      this.fetchNest('site/ajax.php?act=translations_mobile', { handle_strings: translationsMobileHandleStrings }, undefined, undefined, 'post', undefined, true, 0, false)
        .then(response => {
          if (response !== null) {
            this.$store.dispatch('addTranslationsMobile', response.translations_mobile)
          }
        })
    },
    trans (handleString, replaceValues) {
      let translatedString = this.$store.getters.translationByHandleString(handleString)
      if (replaceValues !== null) {
        const handlesToReplace = translatedString.match(/{\w+}/g)
        if (handlesToReplace) {
          handlesToReplace.forEach(handleToReplace => {
            const handleName = handleToReplace.replace('{', '').replace('}', '')
            if (handleName in replaceValues) {
              translatedString = translatedString.replace(handleToReplace, replaceValues[handleName])
            } else if (replaceValues[handleName + '__trans']) {
              translatedString = translatedString.replace(handleToReplace, this.trans(replaceValues[handleName + '__trans']))
            } else {
              console.warn('Missing replacement value for handle: ' + handleToReplace)
              const pageBase = window.location.pathname.replace(/\?(.*)$/, '').replace(/^((.*)\/)?([^/]+)/, '$3')
              window.gaEvent('vueTransReplacementMissing', handleString + ' - ' + handleToReplace, pageBase)
            }
          })
        }
      }
      return translatedString
    },
    transMobile (handleString) {
      return this.$store.getters.translationMobileByHandleString(handleString)
    }
  }
}
</script>
